import React, { useState } from 'react';
import { Button } from '@iwoca/orion';
import { t, Trans } from '@lingui/macro';
import { AddNewApplicationNavItem } from 'components/addNewApplication/AddNewApplicationNavItem';
import { HelpModal } from 'components/Navigation/Help/HelpModal';
import { useApplicationTableState } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import ConfusedGuyLookingAtHisLaptop from 'svg/ConfusedGuyLookingAtHisLaptop';
import GuyWithLaptopIcon from 'svg/GuyWithLaptopIcon';
import styles from './TableStatus.module.css';

export const TableStatus = () => {
  const { status } = useApplicationTableState();
  const [showHelpModal, setShowHelpModal] = useState(false);

  if (status === 'success') {
    return <div data-testid="table-mounted" />;
  }

  return (
    <div
      data-testid={status === 'loading' ? 'table-loading' : 'table-mounted'}
      className={styles.tableStatus}
    >
      <div className={styles.content}>
        {status === 'no results' && (
          <GuyWithLaptopIcon className={styles.icon} />
        )}
        {status === 'empty' && (
          <ConfusedGuyLookingAtHisLaptop className={styles.icon} />
        )}
        <p className={styles.text}>
          {status === 'loading'
            ? t`Loading applications...`
            : status === 'no results'
              ? t`Your search returned no results`
              : t`You have no live applications`}
        </p>
        {status === 'no results' && (
          <>
            <p className={styles.subText}>
              <Trans>
                Have you tried using different filters and checking for typos to
                see if that solves things?
              </Trans>
            </p>
            <p className={styles.subText}>
              <Trans>
                If you’re still not seeing what you expect,{' '}
                <Button
                  variant="tertiary"
                  onClick={() => setShowHelpModal(true)}
                  className={styles.contactButton}
                >
                  contact us
                </Button>{' '}
                for more support?
              </Trans>
            </p>
          </>
        )}
        {status === 'empty' && (
          <AddNewApplicationNavItem className={styles.addButton} />
        )}
      </div>

      <HelpModal
        showModal={showHelpModal}
        closeModal={() => setShowHelpModal(false)}
      />
    </div>
  );
};
